import script from "./offer-card.vue?vue&type=script&setup=true&lang=js"
export * from "./offer-card.vue?vue&type=script&setup=true&lang=js"

import "./offer-card.vue?vue&type=style&index=0&id=cea993f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cea993f8"]])

export default __exports__